/* global Ecwid */
import { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { createUseStyles } from 'react-jss'
import { useSelector, shallowEqual } from 'react-redux'
import classNames from 'classnames'
import DelayLink from '@/components/DelayLink'
import BtnLink from '@/components/BtnLink'
import { decodeEntities } from '@/utils/decodeEntities'
import style from './style'

const useStyles = createUseStyles(style)

const ProductItem = ({
  item,
  shop,
  onAddCartClick,
}) => {
  const classes = useStyles()
  const [hover, setHover] = useState(false)
  const [availability, setAvailability] = useState(true)
  const [unlimited, setUnlimited] = useState(false)
  const [preorder, setPreorder] = useState(false)

  const { mediaQueryKey, strings } = useSelector((state) => ({
    mediaQueryKey: state.mediaQuery.key,
    strings: state.language.string,
  }), shallowEqual)

  const handleMouseMove = (e) => {
    if (e.type === 'mouseenter' && !hover && mediaQueryKey > 1) setHover(true)
    if (e.type === 'mouseleave' && hover && mediaQueryKey > 1) setHover(false)
  }

  /*------------------------------
  Check Availability in Cart
  ------------------------------*/
  const checkAvailability = (cart) => {
    let available = item.quantity > 0
    const itemInCart = cart.items.find((prod) => prod.product.id === item.id)
    if (itemInCart) {
      if (item.quantity <= itemInCart.quantity) {
        available = false
      }
    }
    setAvailability(available)
  }

  useEffect(() => {
    Ecwid.OnCartChanged.add((cart) => {
      checkAvailability(cart)
    })
  }, [])

  /*------------------------------
  Preorder
  ------------------------------*/
  useEffect(() => {
    const isPreordine = item?.attributes?.length > 0 && item.attributes.some((attr) => attr.name === 'Preordine')
    setPreorder(isPreordine)
  }, [])

  /*------------------------------
  Unlimited
  ------------------------------*/
  useEffect(() => {
    setUnlimited(item.unlimited)
  }, [])

  /*------------------------------
  Render Contols
  ------------------------------*/
  const renderControls = () => {
    return (
      <div className={`${classes.cta} productItem__cta`}>
        <BtnLink
          className={classes.btnCta}
          label={(preorder && !availability) || (preorder && unlimited) ? strings.preorder : strings.addtocart_label}
          theme="light"
          onClick={onAddCartClick}
        />
      </div>
    )
  }

  /*------------------------------
  Render Preorder
  ------------------------------*/
  // const renderPreorder = () => {
  //   const activeLanguage = window.location.pathname.split('/')[1]

  //   return (preorder && !availability) || (preorder && unlimited) ? (
  //     <div className={classes.preorder}>
  //       {item.attributes?.find((attr) => attr.name === 'Preordine')?.valueTranslated[activeLanguage]}
  //     </div>
  //   ) : null
  // }

  return (
    <li
      className={classNames({
        [classes.root]: true,
        productItem__root: true,
        [classes.hover]: hover,
        productItem__hover: hover,
      })}
    >
      <div
        className={`${classes.cover} productItem__cover`}
        onMouseEnter={(e) => handleMouseMove(e)}
        onMouseLeave={(e) => handleMouseMove(e)}
      >
        <DelayLink to={item.link}>
          <div className={`${classes.image} productItem__image`}>
            <img src={item.image} alt={item.title} className={classes.img} />
          </div>
        </DelayLink>
      </div>
      <div className={`${classes.desc} productItem__desc`}>
        <div className={`${classes.title} productItem__title`}>
          <DelayLink
            to={item.link}
            onMouseEnter={(e) => handleMouseMove(e)}
            onMouseLeave={(e) => handleMouseMove(e)}
          >
            {decodeEntities(item.title)}
          </DelayLink>
        </div>
        {shop ? (
          <>
            {item.designer && (
              <div className={`${classes.designer} productItem__designer`}>
                {item.designer}
              </div>
            )}
            {item.price && (
              <div className={`${classes.price} productItem__price`}>
                {item.price}
                {item.discountPrice ? (
                  <span className={`${classes.discountPrice} productItem__discountPrice`}>
                    {' '}
                    {item.discountPrice}
                  </span>
                ) : null}
              </div>
            )}
            {renderControls()}
            {/* {(!preorder && !btnCartVisibile) && (
              <div className={`${classes.cta} productItem__cta`}>
                <span>{strings.out_of_stock_label}</span>
              </div>
            )} */}
            {/* {renderPreorder()} */}
          </>
        ) : null}
      </div>
    </li>
  )
}

ProductItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    designer: PropTypes.string,
    price: PropTypes.string,
    image: PropTypes.string,
  }).isRequired,
  shop: PropTypes.bool,
  onAddCartClick: PropTypes.func,
}

ProductItem.defaultProps = {
  shop: false,
  onAddCartClick: undefined,
}

export default ProductItem
